import React, { useEffect, useState } from 'react'

const TypingEffect = ({ text = '', speed = 20 }) => {
    const [displayText, setDisplayText] = useState('')

    useEffect(() => {
        let index = 0
        const interval = setInterval(() => {
            if (index < text.length) {
                setDisplayText((prev) => prev + text[index])
                index++
            } else {
                clearInterval(interval)
            }
        }, speed)

        return () => clearInterval(interval)
    }, [text, speed])

    return (
        <p style={{ margin: 0, padding: 0 }}>
            {/* {displayText} */}
            {String(displayText || '').replace(/\*/g, '')}
        </p>
    )
}

export default TypingEffect